import { render, staticRenderFns } from "./MergeClientView.vue?vue&type=template&id=1c0801b2&"
import script from "./MergeClientView.vue?vue&type=script&lang=js&"
export * from "./MergeClientView.vue?vue&type=script&lang=js&"
import style0 from "./MergeClientView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports